module.exports = __webpack_public_path__ + "static/img/Opportunities_EnjoyingLA_Symphony.e353515.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Opportunities_EnjoyingLA_Symphony.jpg
// module id = 2JNa
// module chunks = 1